import React, { useState, useEffect } from 'react';
import { VictoryChart, VictoryLine, VictoryZoomContainer, VictoryAxis, VictoryLabel} from 'victory';
import SuperTokens from "supertokens-auth-react";
import ThirdPartyPasswordless from "supertokens-auth-react/recipe/thirdpartypasswordless";
import { ThirdPartyPasswordlessAuth, signOut } from "supertokens-auth-react/recipe/thirdpartypasswordless";
import styles from "./styles.module.css"
import axios from "axios";
import Session from "supertokens-auth-react/recipe/session";
import DiscordIcon from "./assets/discord.svg";
import Ru from "./assets/ru.png"
import Tutu from "./assets/tutu.png"
import Desktop from "./assets/desktop.png"
import Tablet from "./assets/tablet.png"

const discordURL = "https://discord.gg/D78RsGfQjq"
const docsURL = "https://docs.hyperbeam.com"
const bookIcon = "https://assets-global.website-files.com/628faf758389ae9687bff8a9/62a042bb98886d2b4a0a0294_book-open-blank-variant%201.svg"
const hyperbeamLogo = "https://assets-global.website-files.com/628faf758389ae9687bff8a9/62a01d145b015a1ea8ba7741_hyperbeam_logo.svg"
const rocketIcon = "https://emojipedia-us.s3.dualstack.us-west-1.amazonaws.com/thumbs/120/google/313/rocket_1f680.png"

const cofounders = [
    {
        name: "Scotty",
        position: "CEO",
        email: "scotty",
        discordTag: "Scotty#1337",
        discordId: "117396758463643653",
        calendlyId: "scottyfillups"
    },
    {
        name: "Amby",
        position: "CTO",
        email: "amby",
        discordTag: "Ambyjkl#4365",
        discordId: "385567130780827648",
        calendlyId: "amby-2"
    },
    {
        name: "Declan",
        position: "CPO",
        email: "declan",
        discordTag: "Declan#7777",
        discordId: "708871387032584223",
        calendlyId: "declan-goncalves"
    },
]

const personalizationKeys = ["ch", "cm", "ct1", "ct2"] // should match: https://docs.google.com/spreadsheets/d/1OqbTnPqbKUEi5oBDhUoPDQyFmqSN5GCF9DyRZ0-5JNg/edit#gid=1922087426

SuperTokens.init({
    appInfo: {
        appName: "Hyperbeam",
        apiDomain: process.env.REACT_APP_ST_API_DOMAIN,
        websiteDomain: process.env.REACT_APP_ST_APP_DOMAIN,
        apiBasePath: process.env.REACT_APP_ST_API_BATH_PATH,
        websiteBasePath: process.env.REACT_APP_ST_APP_BASE_PATH
    },
    recipeList: [
        ThirdPartyPasswordless.init({
            contactMethod: "EMAIL",
            getRedirectionURL: async (context) => {
                if (context.action === "SUCCESS") {
                    if (context.redirectToPath !== undefined) {
                        // we are navigating back to where the user was before they authenticated
                        return context.redirectToPath
                    }
                    return "/dashboard"
                }
                return undefined
            },
            onHandleEvent: async (context) => {
                if (context.action === "SUCCESS") {
                    let user = context.user;
                    window.gtag('config', 'G-7Z9TPHHQXN', {
                        'user_id': user.id
                    });
                    if (context.isNewUser) {
                        // sign up success
                        window.gtag("event", "sign_up", {
                            marketing_channel: sessionStorage.getItem("ch"),
                            customer_type1: sessionStorage.getItem("ct1"),
                            customer_type2: sessionStorage.getItem("ct2"),
                        });
                    } else {
                        // sign in success
                        window.gtag("event", "login");
                    }
                } else if (context.action === "VERIFY_EMAIL_SENT") {
                    window.gtag("event", "verify_email_sent");
                } else if (context.action === "EMAIL_VERIFIED_SUCCESSFUL") {
                    window.gtag("event", "email_verified_successful");
                } else if (context.action === "RESET_PASSWORD_EMAIL_SENT") {
                    window.gtag("event", "reset_password_email_sent");
                } else if (context.action === "PASSWORD_RESET_SUCCESSFUL") {
                    window.gtag("event", "password_reset_successful");
                }
            },
            palette: {
                primary: "#a888ff",
                background: "#272832",
                textTitle: "rgba(255, 255, 255, 0.8)",
                textLabel: "rgba(255, 255, 255, 0.8)",
                textInput: "rgba(255, 255, 255, 0.8)",
                textPrimary: "rgba(255, 255, 255, 0.8)",
                textLink: "rgba(255, 255, 255, 0.8)",
                inputBackground: "#1b1c21",
                buttonText: "000"
            },
            style: {
                container: {
                    backgroundColor: "#272832",
                    fontFamily: "Open sans",
                },
                providerButtonText: {
                    fontFamily: "Open sans",
                },
                link: {
                    fontFamily: "Open sans"
                },
                superTokensBranding: {
                    display: "none"
                }
            },
            signInUpFeature: {
                providers: [
                    ThirdPartyPasswordless.Github.init(),
                    ThirdPartyPasswordless.Google.init(),
                    // ThirdPartyPasswordless.Apple.init(),
                ]
            }
        }),
        Session.init()
    ]
});
Session.addAxiosInterceptors(axios)

async function onLogout() {
    await signOut()
    window.location.href = process.env.REACT_APP_ST_APP_BASE_PATH
}

function Inf() {
    return <span className={styles.infinity}>∞</span>
}

// https://formidable.com/open-source/victory/guides/zoom-on-large-datasets
// https://formidable.com/open-source/victory/guides/tooltips
// https://formidable.com/open-source/victory/gallery/brush-and-zoom
function Graph({usageData}) {
    const data = usageData.map(d => ({
        date: new Date(d.date),
        mins: Math.floor(d.watch_duration_s / 60)
    }))
    return (
        <div style={{ width: "100%" }}>
            <VictoryChart
                width={600}
                height={400}
                domain={{y: [0, 1000]}}
                padding={{top: 20, right: 20, bottom: 54, left: 80}}
                scale={{x: "time"}}
                containerComponent={
                    usageData.length < 20
                        ? undefined
                        : <VictoryZoomContainer zoomDimension="x" />
                }
            >
                <VictoryLine
                    style={{
                        data: { stroke: "#a888ff", strokeWidth: 3 },
                    }}
                    data={data}
                    x="date"
                    y="mins"
                />
                <VictoryAxis dependentAxis
                    label="Minutes"
                    axisLabelComponent={(
                        <VictoryLabel
                            verticalAnchor="middle"
                            textAnchor="start"
                            dy={-30}
                        />
                    )}
                    style={{tickLabels: {fill: "#fff"}, axisLabel: {fill: "#fff"}, axis: {stroke: "#fff"}}}
                />
                <VictoryAxis
                    label="Time"
                    axisLabelComponent={(
                        <VictoryLabel
                            verticalAnchor="middle"
                            textAnchor="start"
                            dy={20}
                        />
                    )}
                    style={{tickLabels: {fill: "#fff"}, axisLabel: {fill: "#fff"}, axis: {stroke: "#fff"}}}
                />
            </VictoryChart>
        </div>
    );
}

function formatYYYYMMDD(date) {
    if (typeof date === "string") {
        date = new Date(date)
    }
    const offset = date.getTimezoneOffset()
    const dateWithOffset = new Date(date.getTime() - (offset*60*1000))
    return dateWithOffset.toISOString().split('T')[0]
}

function csvDownload(csvString, title) {
    const blob = new Blob([csvString], { type: 'text/csv' })
    const url = window.URL.createObjectURL(blob)
    const a = document.createElement('a')
    a.setAttribute('href', url)
    a.setAttribute('download', title)
    a.click()
}

function csvStringify(data) {
    if (data.length === 0) {
        return ""
    }
    const csvRows = []
    const headers = Object.keys(data[0])
    csvRows.push(headers.join(','))
    for (const row of data) {
        const values = Object.values(row).join(',')
        csvRows.push(values)
    }
    return csvRows.join('\n')
}

function copyToClipboardFallback(text) {
  const textArea = document.createElement("textarea")
  textArea.value = text

  // Avoid scrolling to bottom
  textArea.style.top = "0"
  textArea.style.left = "0"
  textArea.style.position = "fixed"
  textArea.style.visibility = "hidden"

  document.body.appendChild(textArea)
  textArea.focus()
  textArea.select()

  try {
    document.execCommand('copy')
  } catch (e) {
    console.error("document.execCommand:", e)
  }
  document.body.removeChild(textArea)
}

function copyToClipboard(text) {
  if (!navigator.clipboard) {
    copyToClipboardFallback(text)
    return
  }
  return navigator.clipboard.writeText(text).catch(console.error)
}

function Tooltip(props) {
    return (
        <div className={styles.tooltip} onClick={props.onClick}>
            {props.children}
            <span className={styles.tooltiptext}>{props.value}</span>
        </div>
    )
}

function APIKey(props) {
    const [tooltipText, setTooltipText] = useState("Click to copy")
    const onClick = () => {
        const oldText = tooltipText
        copyToClipboard(props.value).then(() => {
            setTooltipText("Copied!")
        })
        setTimeout(() => {
            setTooltipText(oldText)
        }, 2000)
    }
    return <Tooltip value={tooltipText} onClick={onClick}><code>{props.value}</code></Tooltip>
}

function Dashboard() {
    const [loadingInfo, setLoadingInfo] = useState(true)
    const [testUsage, setTestUsage] = useState({minutes: 0, vm_count: 0})
    const [prodUsage, setProdUsage] = useState({minutes: 0, vm_count: 0})
    const [testKey, setTestKey] = useState(undefined)
    const [prodKey, setProdKey] = useState(undefined)
    const [billingType, setBillingType] = useState(null)
    const [cancelAt, setCancelAt] = useState(null)
    const [showTestKey, setShowTestKey] = useState(false)
    const [usageData, setUsageData] = useState([])
    const now = formatYYYYMMDD(new Date())

    const onRevealTestKey = () => {
        if (testKey) {
            setShowTestKey(true)
        } else {
            axios.post(process.env.REACT_APP_API_BASE_URL + "/dashboard/keys", { test: true })
                .then(resp => {
                    setTestKey(resp.data.key)
                    setShowTestKey(true)
                })
                .catch(console.error)
        }
    }

    const onCreateProdKey = () => {
        alert("Your production key will only be presented to you once. Make sure you copy it immediate.")
        axios.post(process.env.REACT_APP_API_BASE_URL + "/dashboard/keys", { test: false })
            .then(resp => {
                setProdKey(resp.data.key)
            })
            .catch(console.error)
    }

    const onExportCSV = () => {
        const csvData = usageData.map(d => ({ time: d.date, minutes: Math.floor(d.watch_duration_s / 60) }))
        const csvString = csvStringify(csvData)
        csvDownload(csvString, "hyperbeam-usage-" + (new Date()).getTime().toString())
    }

    const loadData = () => axios
            .get(process.env.REACT_APP_API_BASE_URL + "/dashboard/info")
            .then(resp => {
                const data = resp.data
                setLoadingInfo(false)
                setBillingType(data.billing_type)
                setUsageData(data.usage_data)
                if (data.cancel_at) {
                    setCancelAt(new Date(data.cancel_at))
                }
                for (const key of data.keys) {
                    if (key.test) {
                        setTestKey(key)
                    } else {
                        setProdKey(key)
                    }
                }
                for (const usage of data.usage_summary) {
                    if (usage.test) {
                        setTestUsage(usage)
                    } else {
                        setProdUsage(usage)
                    }
                }
            })
            .catch(console.error)

    useEffect(() => {
        const params = new URLSearchParams(window.location.search)
        const dataPromise = loadData()
        if (params.get("success") === "true") {
            // TODO: show celebration modal, maybe through some confetti
            dataPromise.then(() => { // The API may return stale data, as it's a race
                setBillingType("paid")
            })
        }
    }, [])

    return (
        <div className={styles.dashboard}>
            <header>
                <img src={hyperbeamLogo} className={styles.logo} alt="Hyperbeam" /><br />
                <a href={docsURL} className={styles.noUnderline}><span className={styles.buttonSpan}>Docs</span></a>
                <a href={discordURL} className={styles.noUnderline}><span className={styles.buttonSpan}>Community</span></a>
                <a href="#need-help" className={styles.noUnderline}><span className={styles.buttonSpan}>Talk to founders</span></a>
                <button className={`${styles.buttonMiniSecondary} ${styles.flexEnd}`}onClick={onLogout}>Logout</button>
            </header>
            <main>
                <div>
                    <h2>Getting started?</h2>
                    {showTestKey
                        ? (
                            <p>
                                Your test key is <span className={styles.testKeyHighlight}>
                                    <APIKey value={testKey.key_preview} />
                                </span>
                            </p>
                        ) : <p><button className={styles.buttonTiny} onClick={onRevealTestKey}>Click here</button> to reveal your test key.</p>}
                    <p>Integrate in minutes with our quickstart guide in the docs.</p>
                    <p>Stuck? Join our Discord server to get help from our community.</p>
                    <a className={styles.buttonWrapperLink} href={discordURL}>
                        <button className={styles.buttonPrimary}>
                            <img className={styles.buttonImage} src={DiscordIcon} alt="watch party icon"  />
                            Join Discord
                        </button>
                    </a>
                    <a className={styles.buttonWrapperLink} href={docsURL}>
                        <button className={`${styles.buttonSecondary} ${styles.buttonLeftMargin}`}>
                            <img src={bookIcon} className={styles.buttonImage} alt="Open book" />
                            Docs
                        </button>
                    </a>
                </div>
                <div>
                    <h2>API keys</h2>
                    <p>Your API key should only be used on the backend, <strong>do not expose your API keys to the client.</strong></p>
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Token</th>
                                <th>Last Used</th>
                                <th>Created</th>
                                {/* TODO(scotty): Add roll key functionality once supertokens has better interface for re-auth + need to figure out UI (e.g. modals) */}
                                {/* <th></th> */}
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Test Secret Key</td>
                                <td style={{width: 420}}>
                                    {showTestKey
                                        ? <APIKey value={testKey.key_preview} />
                                        : <button className={styles.buttonTiny} onClick={onRevealTestKey}>Reveal test key</button>}
                                </td>
                                <td>{testKey?.last_used_date ? formatYYYYMMDD(testKey.last_used_date) : "-"}</td>
                                <td>{testKey ? formatYYYYMMDD(testKey.creation_date) : now}</td>
                                {/* <td><button className={styles.buttonTiny}>Roll</button></td> */}
                            </tr>
                            <tr>
                                <td>Production Secret Key</td>
                                <td>
                                    {(function() {
                                        if (loadingInfo) return <code>sk_live_.......</code>
                                        if (prodKey) return <APIKey value={prodKey.key_preview} />
                                        return <button className={styles.buttonTiny} onClick={onCreateProdKey}>Create production key</button>
                                    }())}
                                </td>
                                <td>{prodKey?.last_used_date ? formatYYYYMMDD(prodKey.last_used_date) : "-"}</td>
                                <td>{prodKey ? formatYYYYMMDD(prodKey.creation_date) : "-"}</td>
                                {/* <td><button className={styles.buttonTiny}>Roll</button></td> */}
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div>
                    <h2>This month</h2>
                    <table>
                        <thead>
                            <tr>
                                <th>Environment</th>
                                <th>Active computers</th>
                                <th>Minutes used</th>
                                <th>Minutes remaining</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>Testing</td>
                                <td>{testUsage.vm_count} / 2</td>
                                <td>{testUsage.minutes}</td>
                                <td><Inf /></td>
                            </tr>
                            <tr>
                                <td>Production</td>
                                <td>{prodUsage.vm_count} / {billingType === "free" ? "10" : <Inf />}</td>
                                <td>{prodUsage.minutes}</td>
                                <td>{billingType === "free" ? (Math.max(0, 10000 - prodUsage.minutes)).toString() : <Inf />}</td>
                            </tr>
                        </tbody>
                    </table>
                    <div>
                        {(() => {
                            switch (billingType) {
                                case "free":
                                    return (
                                        <div>
                                            <p>You are currently on the <strong>free plan</strong>.</p>
                                            <p>Need more minutes? Want to bump up your concurrent computer limit?</p>
                                            <form action={process.env.REACT_APP_API_BASE_URL + "/dashboard/checkout"} method="POST">
                                                <input type="hidden" name="priceId" value={process.env.REACT_APP_PRICE_ID}></input>
                                                <input type="hidden" name="successURL" value={`${window.location.origin}${window.location.pathname}?success=true`}></input>
                                                <input type="hidden" name="cancelURL" value={window.location.origin + window.location.pathname}></input>
                                                <button type="submit" className={styles.buttonTertiary}>
                                                    <img src={rocketIcon} className={styles.buttonImage} alt="Upgrade!" />
                                                    Upgrade!
                                                </button>
                                            </form>
                                        </div>
                                    )
                                case "paid":
                                    return (
                                        <div>
                                            {cancelAt
                                                ? <p>Your plan will be <strong>canceled</strong> on {cancelAt.toLocaleString("en-US", {year: "numeric", month: "long", day: "numeric"})}.</p>
                                                : <p>You are currently on the <strong>paid plan</strong>.</p>
                                            }
                                            <form action={process.env.REACT_APP_API_BASE_URL + "/dashboard/portal"} method="POST">
                                                {/* We use window.location.origin + window.location.pathname to strip out the query params */}
                                                {/* For example, we don't want to keep ?success=true on a cancel */}
                                                <input type="hidden" name="returnURL" value={window.location.origin + window.location.pathname}></input>
                                                <button type="submit" className={styles.buttonSecondary}>Go to billing portal</button>
                                            </form>
                                        </div>
                                    )
                                default:
                                    return null
                            }
                        })()}
                    </div>
                </div>
                <div>
                    <h2>Usage history</h2>
                    <button className={styles.buttonMiniSecondary} onClick={onExportCSV}>Export to CSV</button>
                    <Graph usageData={usageData} /><br />
                </div>
                <div>
                    <h2 id="need-help" className={styles.myStyle}>Need help?</h2>
                    <a className={styles.buttonWrapperLink} href={discordURL}>
                        <button className={styles.buttonPrimary}>
                            <img className={styles.buttonImage} src={DiscordIcon} alt="watch party icon"  />
                            Ask Discord community
                        </button>
                    </a>
                    <a className={styles.buttonWrapperLink} href="mailto:founders@hyperbeam.com">
                        <button className={`${styles.buttonSecondary} ${styles.buttonLeftMargin}`}>Email the founders</button>
                    </a>
                    <br />
                    <br />
                    <table>
                        <thead>
                            <tr>
                                <th>Name</th>
                                <th>Position</th>
                                <th>Email</th>
                                <th>Discord</th>
                                <th>Want to chat?</th>
                            </tr>
                        </thead>
                        <tbody>
                            {cofounders.map(c => <tr key={c.name}>
                                <td>{c.name}</td>
                                <td>{c.position}</td>
                                <td><a href={`mailto:${c.email}@hyperbeam.com`}>{c.email}@hyperbeam.com</a></td>
                                <td><a href={`https://discordapp.com/users/${c.discordId}`}>{c.discordTag}</a></td>
                                <td><a href={`https://calendly.com/${c.calendlyId}/30min`}>Meeting link</a></td>
                            </tr>)}
                        </tbody>
                    </table>
                </div>
            </main>
        </div>
    )
}

function Auth() {
    const [hideWPNotice, setHideWPNotice] = useState(false);
    const [showForm, setShowForm] = useState(false);
    if (!hideWPNotice) {
        for (const k of personalizationKeys) {
            if (sessionStorage.getItem(k)) {
                setHideWPNotice(true)
                setShowForm(true)
                break
            }
        }
    }
    return (
        <div className={styles.authContainer}>
        <div className={styles.header}>
            <img src={hyperbeamLogo} className={styles.logo} alt="Hyperbeam" />
        </div>
            <div className={styles.auth}>
            <div>
                {!hideWPNotice &&
                !showForm &&
                <div className={styles.topBanner} onClick={() => { window.location.href="https://watch.hyperbeam.com/"}}>
                    <div className={styles.mascotImgContainer}>
                        <img src={Ru} alt="mascot ru"  />
                    </div>
                    <span>
                        I am looking for <br />
                        <span className={styles.purpleText}>Hyperbeam Watch Party</span>
                    </span>
                    <div className={styles.mascotImgContainer}>
                        <img src={Tutu} alt="mascot tutu"  />
                    </div>
                </div>
                }
                {!hideWPNotice &&
                !showForm &&
                    <div className={styles.orText}>OR</div>
                }
                {hideWPNotice || showForm ?
                <div className={styles.signupNotice}>
                    Embed <span className={styles.purpleText}>Virtual Computers</span>
                </div> :
                !showForm &&
                <div className={styles.signupBanner} onClick={() => { setShowForm(true) }}>
                    <img src={Tablet} alt="mascot tutu"  />
                    <span>
                        I am a developer looking to embed <span className={styles.purpleText}>Virtual Computers</span> in my product
                    </span>
                    <img src={Desktop} alt="mascot ru"  />
                </div>
                }
            </div>
            <div style={{ display: showForm ? "block" : "none" }}>
                {SuperTokens.getRoutingComponent()}
            </div>
            </div>
        </div>
    )
}

function App() {
    if (SuperTokens.canHandleRoute()) {
        // This renders the login UI on the /auth route
        return <Auth />
    }
    return (
        <ThirdPartyPasswordlessAuth>
            <Dashboard />
        </ThirdPartyPasswordlessAuth>
    )
}

export default App;
